<template>
<div>
    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-area
            title="Laboratório"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.unidades"
                        label="Laboratório"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="cotalaboratorio.unidadeId"
                        disabled
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nome"
                        v-model="cotalaboratorio.infraestruturaId"
                        disabled
                        valueField="id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Tipo"
                        v-model="cotalaboratorio.cotaTipoNome"
                        disabled
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1" v-show="cotalaboratorio.cotaTipoId == enums.tipoCota.QUANTIDADE">
                    <rkm-form-input
                        label="Cota laboratório"
                        v-model="cotalaboratorio.cotaQuantidade"
                        number
                        disabled
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1" v-show="cotalaboratorio.cotaTipoId != enums.tipoCota.QUANTIDADE">
                    <rkm-form-input
                        label="Cota"
                        ref="cotaValor"
                        v-model="cotalaboratorio.cotaValor"
                        v-money="money"
                        prepend="R$"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="model.periodo"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            title="Exame"
            type="fieldset"
        >
            <rkm-row>

                <rkm-col cols="9">
                    <rkm-form-input
                        label="Exame"
                        v-model="item.nome"
                        disabled
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Cota exame"
                        v-model="item.cota"
                        disabled
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>

            <rkm-col
                cols="12"
            >
                <rkm-area
                    :title="checkHandleAlter ? 'Alterar cota - Unidade Solicitante' : 'Cadastrar cota - Unidade Solicitante'"
                    type="fieldset"
                >

                    <rkm-row>

                        <rkm-col cols="4">
                            <rkm-form-select
                                :options="data.form.unidades"
                                :validations="validations.unidadeSolicitante"
                                label="Unidade Solicitante"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="unidadeSolicitante.unidadeSolicitanteId"
                                :disabled="isReadOnly ? true : false"
                                value-field="id"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-select
                                label="Local de atendimento"
                                :options="infraestruturasSolicitante"
                                :validations="validations.infraestruturasSolicitante"
                                textField="nome"
                                v-model="unidadeSolicitante.infraestruturaSolicitanteId"
                                :disabled="isReadOnly ? true : false"
                                valueField="id"
                                show-default-option
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1" v-show="cotalaboratorio.cotaTipoId == enums.tipoCota.QUANTIDADE">
                            <rkm-form-input
                                label="Cota"
                                v-model="unidadeSolicitante.cotaQuantidade"
                                :validations="cotalaboratorio.cotaTipoId == enums.tipoCota.QUANTIDADE ? validations.cotaQuantidade : {}"
                                number
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1" v-show="cotalaboratorio.cotaTipoId != enums.tipoCota.QUANTIDADE">
                            <rkm-form-input
                                label="Cota"
                                ref="unidadeSolicitanteValor"
                                v-model="unidadeSolicitante.cotaValor"
                                :validations="cotalaboratorio.cotaTipoId == enums.tipoCota.VALOR ? validations.cotaValor : {}"
                                v-money="money"
                                prepend="R$"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0" v-if="checkHandleAlter">

                            <rkm-button
                                :label="false"
                                color="secondary"
                                @click.stop="hideAlter()"
                            >
                                Voltar
                            </rkm-button>
                        </rkm-col>

                        <rkm-col class="flex-grow-0" >

                            <rkm-button
                                :label="false"
                                color="primary"
                                @click.stop="handleCota({exameId: item.exameId})"
                            >
                                {{ checkHandleAlter ? 'Alterar' : 'Incluir' }}
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                    <List
                        v-if="!checkHandleAlter"
                        :data="data"
                        :unidadeId="cotalaboratorio.unidadeId"
                        :infraestruturaId="cotalaboratorio.infraestruturaId"
                        :indexExame="indexExame"
                        :indexItem="indexItem"
                        :unidadeSolicitante="this.item.unidadeSolicitante"
                        :unidadeSolicitantesum="this.unidadeSolicitantesum"
                        :cotaTipoId="cotalaboratorio.cotaTipoId"
                        :cotalaboratorio="cotalaboratorio"
                        :periodo="model.periodo"
                        :item="item"
                        @handleAlter="handleAlter"
                        @checkSum="checkSum"
                    />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import List from './List'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

//Directives
import { VMoney } from 'v-money'

export default {
    components: { List },
    directives: { money: VMoney },
    computed: {
        validations() {

            return {
                unidadeSolicitante: { required: true },
                infraestruturasSolicitante: { required: true },
                cotaQuantidade: { required: true },
                cotaValor: { max: 13, min_value: 0.01  },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.cotalaboratorio.unidadeId) {

                return this.data.form.unidades.find(u => u.id === this.cotalaboratorio.unidadeId).infraestruturas
            }

            return []
        },
        infraestruturasSolicitante() {

            if (this.unidadeSolicitante.unidadeSolicitanteId) {

                 let infraestruturaPrincipal =  this.data.form.unidades.find(u =>
                    u.id === this.unidadeSolicitante.unidadeSolicitanteId).infraestruturas

                if (!this.isReadOnly) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }

        this.load()
    },
    data: () => ({
        form: {
            exames: {},
        },
        unidadeSolicitante: {
            id: null,
            unidadeSolicitanteId: null,
            infraestruturaSolicitanteId: null,
            cota: null,
            cotaValor: null,
            cotaQuantidade: null,
            saldo: null,
            transferencia: '0',
            valorUtilizado: '0',
            quantidadeUtilizada: '0',
            utilizada: '0',
        },
        enums: {
            tipoCota
        },
        model: {
            periodo: {
                start: null,
                end: null
            },
        },
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        isReadOnly: false,
        checkHandleAlter: false,
        unidadeSolicitantesum: 0,
        index: null,
        cotaOld: null,
        cotaUnidade: null,
        dataInicioUnidade: null,
        dataFimUnidade: null,
        cotasAtribuidas: null,
        cotaAtribuida: null,
        atribuiNovaCota: null,
        limiteCota: false,
        cotaIdUnidadeSolicitante: null,
        addCota: false,
        cotaAtribuidaUnidade: null,
        utilizada: 0,
        utilizadas: 0,
        saldoUtilizadas: 0,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo.start = moment(
                this.cotalaboratorio.periodo.start,
                'DD/MM/YYYY'
            ).toDate()

            this.model.periodo.end = moment(
                this.cotalaboratorio.periodo.end,
                'DD/MM/YYYY'
            ).toDate()

            this.item.unidadeSolicitante.map(saldo => {

                if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {
                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(saldo.cota);
                } else {
                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(saldo.cota);
                }
            })
        },
        add() {

            this.resetCotas()

            if (this.item.unidadeSolicitante.find(s => s.id !== this.unidadeSolicitante.id
                && s.unidadeSolicitanteId === this.unidadeSolicitante.unidadeSolicitanteId
                && s.infraestruturaSolicitanteId === this.unidadeSolicitante.infraestruturaSolicitanteId)) {

                    this.showValidationNotification('Unidade solicitante e local de atendimento já cadastrados')

                    return false
            }

            this.getCotaAtribuidaUnidadeSolicitante()

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cotaValor = this.unidadeSolicitante.cotaValor.replace('.','').replace(',','.')

                let transferencia = this.formatMoney(this.unidadeSolicitante.transferencia)
                transferencia = this.formatSumMoney(transferencia)

                if (this.cotasAtribuidas > 0 && this.cotasAtribuidas < cotaValor) {

                    const unidade = this.data.form.unidades.find(s => s.id === this.unidadeSolicitante.unidadeSolicitanteId)
                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.unidadeSolicitante.infraestruturaSolicitanteId).nome

                    this.showValidationNotification(`A cota é menor que a cota atribuída
                        para as unidades solicitantes em (Parametrização > Cotas
                        > Laboratório > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                        local de atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong> R$ ${this.formatMoney(this.cotasAtribuidas,2)}</strong>.
                        `)

                    this.cotasAtribuidas = 0

                    return false
                }

                 if (transferencia > cotaValor) {

                    this.showValidationNotification(`O valor da cota informada está menor que o valores das cotas
                        transferidas.`)

                    return false
                }

            } else {

                if (this.cotasAtribuidas > 0 && this.cotasAtribuidas < this.unidadeSolicitante.cotaQuantidade) {

                    const unidade = this.data.form.unidades.find(s => s.id === this.unidadeSolicitante.unidadeSolicitanteId)
                    const infraestrutura = unidade.infraestruturas.find(s => s.id === this.unidadeSolicitante.infraestruturaSolicitanteId).nome

                    this.showValidationNotification(`A cota é menor que a cota atribuída
                        para as unidades solicitantes em (Parametrização > Cotas
                        > Laboratório > Unidades solicitantes), para o laboratório <strong>${unidade.nomeFantasia}</strong> e o
                        local de atendimento <strong>${infraestrutura}</strong> no período de
                        <strong>${this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY')}</strong> até
                        <strong>${this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY')}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.formatMoney(this.cotasAtribuidas,0)}</strong>.
                        `)

                    this.cotasAtribuidas = null

                    return false
                }

                 if (this.unidadeSolicitante.transferencia > this.unidadeSolicitante.cotaQuantidade) {

                    this.showValidationNotification(`O valor da cota informada está menor que o valores das cotas
                        transferidas.`)

                    return false
                }
            }

            const exameNome = this.data.form.exames.find(s => s.id === this.item.exameId).nome
            const unidade = this.data.form.unidades.find(s => s.id === this.unidadeSolicitante.unidadeSolicitanteId)
            const infraestruturaNome = unidade.infraestruturas.find(s =>
                s.id === this.unidadeSolicitante.infraestruturaSolicitanteId).nome

            const laboratorio = this.data.form.unidades.find(s => s.id === this.cotalaboratorio.unidadeId)
            const laboratorioInfraestruturaNome = laboratorio.infraestruturas.find(s =>
                s.id === this.cotalaboratorio.infraestruturaId).nome

            let utilizadas = this.utilizadas
            let cotaValor = this.unidadeSolicitante.cota

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                utilizadas = this.utilizadas.replace('.','').replace(',','.')
                cotaValor = this.unidadeSolicitante.cota.replace('.','').replace(',','.')

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos exames
                        <strong>(${exameNome})</strong> agendados para o laboratório
                        <strong>${laboratorio.nomeFantasia}</strong> e o local de
                        atendimento <strong>${laboratorioInfraestruturaNome}</strong>,
                        unidade solicitante <strong>${unidade.nomeFantasia}</strong> e o local de
                        atendimento <strong>${infraestruturaNome}</strong>  no período de
                        <strong>${this.cotalaboratorio.periodo.start} até
                        ${this.cotalaboratorio.periodo.end}</strong>.
                        A cota deve ser maior ou igual a <strong>R$ ${this.utilizadas}</strong>.
                        `)

                    return false
                }
            } else {

                if (parseFloat(utilizadas) > parseFloat(cotaValor)) {

                    this.showValidationNotification(`A cota é menor que a soma dos exames
                        <strong>(${exameNome})</strong> agendados para o laboratório
                        <strong>${laboratorio.nomeFantasia}</strong> e o local de
                        atendimento <strong>${laboratorioInfraestruturaNome}</strong>,
                        unidade solicitante <strong>${unidade.nomeFantasia}</strong> e o local de
                        atendimento <strong>${infraestruturaNome}</strong>  no período de
                        <strong>${this.cotalaboratorio.periodo.start} até
                        ${this.cotalaboratorio.periodo.end}</strong>.
                        A cota deve ser maior ou igual a <strong>${this.utilizadas}</strong>.
                        `)

                    return false
                }
            }

            let verifyUnidade = this.data.model.cotasUnidadeSolicitante.find(cota =>
                cota.unidadeId == this.unidadeSolicitante.unidadeSolicitanteId
                && cota.infraestruturaId == this.unidadeSolicitante.infraestruturaSolicitanteId)

            if (verifyUnidade) {

                let verifyTipo = verifyUnidade.cotaUnidadeSolicitante.filter((unidade) =>
                    unidade.cotaTipoId == this.cotalaboratorio.cotaTipoId
                    && moment(
                        unidade.periodo.start.split("/").reverse().join("-")
                    ).isBetween(
                        this.cotalaboratorio.periodo.start.split("/").reverse().join("-"),
                        this.cotalaboratorio.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        unidade.periodo.end.split("/").reverse().join("-"),
                    ).isBetween(
                        this.cotalaboratorio.periodo.start.split("/").reverse().join("-"),
                        this.cotalaboratorio.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                )

                if (verifyTipo.length) {

                    this.getTotalUnidade()

                    if (!this.limiteCota) {

                        this.showValidationNotification(`A cota ultrapassa o limite definido por período para a ' +
                            'unidade solicitante e o local de atendimento ${this.cotaUnidade}.`)

                        return false
                    }

                    if (!this.addCota) {

                        this.showValidationNotification(`A cota ultrapassa o limite definido por período para a ' +
                            'unidade solicitante e o local de atendimento. ${this.cotaUnidade}`)

                        return false
                    }
                }
            }

            const unidadeSolicitante = this.clone(this.unidadeSolicitante)

            if (unidadeSolicitante.id == null) {

                unidadeSolicitante.id = this.uniqueId(`e-${unidadeSolicitante.infraestruturaSolicitanteId}`)
            }

            unidadeSolicitante.unidadeSolicitante = this.data.form.unidades
                .find(s => s.id === unidadeSolicitante.unidadeSolicitanteId).nomeFantasia

            unidadeSolicitante.infraestruturaNome = this.infraestruturasSolicitante
                .find(s => s.id === unidadeSolicitante.infraestruturaSolicitanteId).nome

            unidadeSolicitante.infraestruturaId = this.infraestruturaId
            unidadeSolicitante.unidadeId = this.unidadeId

            if (this.hasIndex) {

                if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - this.formatSumMoney(this.cotaOld);
                } else {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - Number(this.cotaOld);
                }
            }

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                unidadeSolicitante.cota = this.unidadeSolicitante.cotaValor
            } else {

                unidadeSolicitante.cota = this.unidadeSolicitante.cotaQuantidade
            }

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(unidadeSolicitante.cota);
            } else {

                this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(unidadeSolicitante.cota);
            }

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                if (this.unidadeSolicitantesum > this.item.cota) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - Number(unidadeSolicitante.cota);

                    if (this.hasIndex) {

                        this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(this.cotaOld);
                    }

                    this.showValidationNotification('A cota ultrapassa o limite definido por período para o exame neste laboratório.')

                    return false
                }
            }

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.unidadeSolicitantesum > this.formatSumMoney(this.item.cota)) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum - this.formatSumMoney(unidadeSolicitante.cota);

                    if (this.hasIndex) {

                        this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(this.cotaOld);
                    }

                    this.showValidationNotification('A cota ultrapassa o limite definido por período para o exame neste laboratório.')

                    return false
                }
            }

            const obj = this.item.unidadeSolicitante.findIndex((obj =>
                obj.infraestruturaSolicitanteId == this.unidadeSolicitante.infraestruturaSolicitanteId));

            if (obj >= 0) {

                this.$set(this.item.unidadeSolicitante, obj, this.clone(unidadeSolicitante))
                this.index = null
                this.checkHandleAlter = false
            } else {

                this.item.unidadeSolicitante.push(unidadeSolicitante)
            }

            this.$emit('save')

            this.isReadOnly = false

            this.resetForm()

        },
        handleCota(item) {

            this.setLoading()

            const data = this.cotalaboratorio

            this.repositories.saldo.saldoExame({
                unidade_id: data.unidadeId,
                infraestrutura_id: data.infraestruturaId,
                exame_id: this.item.exameId,
                inicio: data.periodo.start.split("/").reverse().join("-"),
                fim: data.periodo.end.split("/").reverse().join("-"),
                solicitante_infraestrutura_id: this.unidadeSolicitante.infraestruturaSolicitanteId,
            })
                .then(response => {

                    if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                        this.unidadeSolicitante.cota = this.unidadeSolicitante.cotaValor
                    } else {

                        this.unidadeSolicitante.cota = this.unidadeSolicitante.cotaQuantidade
                    }

                    item.cota = this.unidadeSolicitante.cota
                    this.getCotaUtilizada(data, response.data, item)
                    this.$refs.Form.validate(this.add)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getCotaUtilizada(cotaExamePeriodo, items, item) {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            const cota = items.cotasLaboratorio.find((unidade) => unidade.unidadeId == cotaExamePeriodo.unidadeId
                && unidade.infraestruturaId == cotaExamePeriodo.infraestruturaId)

            if (cota) {

                cota.cotaLaboratorio.filter(field => field.cotaTipoId == cotaExamePeriodo.cotaTipoId
                    && moment(
                        field.periodo.start.split("/").reverse().join("-")
                    )
                    .isBetween(
                        this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                        this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
                        null,
                        '[]'
                    )
                    && moment(
                        field.periodo.end.split("/").reverse().join("-")
                    )
                    .isBetween(
                        this.getFormatedDate(this.model.periodo.start, 'YYYY-MM-DD'),
                        this.getFormatedDate(this.model.periodo.end, 'YYYY-MM-DD'),
                        null,
                        '[]'
                    )
                ).map(exame => {

                    this.cotaAtribuida = exame.exames.filter(field => field.exameId == cotaExamePeriodo.exameId)
                        .reduce((sum, element) => {

                            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                            return sum
                        },0)

                    this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                })
            }

            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 2)
                this.saldoAtribuidas = this.formatSumMoney(item.cota) - this.formatSumMoney(this.cotasAtribuidas)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 2)
                let valorAgendado = this.formatMoney(parseFloat(items.valorAgendado), 2)

                if (this.cotasAtribuidas > 0 || this.cotasAtribuidas > '0,00') {

                    this.saldoUtilizadas = this.formatSumMoney(this.cotasAtribuidas) - this.formatSumMoney(valorAgendado)
                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 2)
                    this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
                } else {

                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 2)
                    this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
                }
            } else {

                this.saldoAtribuidas = item.cota - Number(this.cotasAtribuidas)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 0)
                this.cotasAtribuidas = this.formatMoney(this.cotasAtribuidas, 0)

                this.utilizadas = items.quantidadeAgendada

                if (this.cotasAtribuidas > 0) {

                    this.saldoUtilizadas = this.cotasAtribuidas - Number(this.utilizadas)
                    this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 0)
                }
            }
        },
        getTotalUnidade() {

            this.data.model.cotasUnidadeSolicitante.find(cota => cota.unidadeId == this.unidadeSolicitante.unidadeSolicitanteId
                && cota.infraestruturaId == this.unidadeSolicitante.infraestruturaSolicitanteId).cotaUnidadeSolicitante
                .filter((unidade) => unidade.cotaTipoId == this.cotalaboratorio.cotaTipoId
                    && moment(
                        unidade.periodo.start.split("/").reverse().join("-")
                    ).isBetween(
                        this.cotalaboratorio.periodo.start.split("/").reverse().join("-"),
                        this.cotalaboratorio.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                    && moment(
                        unidade.periodo.end.split("/").reverse().join("-"),
                    ).isBetween(
                        this.cotalaboratorio.periodo.start.split("/").reverse().join("-"),
                        this.cotalaboratorio.periodo.end.split("/").reverse().join("-"),
                        null,
                        '[]'
                    )
                ).map(cotaUnidade => {

                    if (!this.dataInicioUnidade) {

                        this.dataInicioUnidade = cotaUnidade.periodo.start.split("/").reverse().join("-")
                    } else {

                        if (moment(cotaUnidade.periodo.start.split("/").reverse().join("-")).isBefore(this.dataInicioUnidade)) {

                            this.dataInicioUnidade = cotaUnidade.periodo.start.split("/").reverse().join("-")
                        }
                    }

                    if (!this.dataFimUnidade) {

                        this.dataFimUnidade = cotaUnidade.periodo.end.split("/").reverse().join("-")
                    } else {

                        if (moment(cotaUnidade.periodo.end.split("/").reverse().join("-")).isAfter(this.dataFimUnidade)) {

                            this.dataFimUnidade = cotaUnidade.periodo.end.split("/").reverse().join("-")
                        }
                    }

                    if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.QUANTIDADE) {

                        if (cotaUnidade.cota) {

                            this.cotaUnidade = this.cotaUnidade + Number(cotaUnidade.cota);
                        }

                    } else {

                        if (cotaUnidade.cota) {

                            this.cotaUnidade = this.cotaUnidade + this.formatSumMoney(cotaUnidade.cota);
                        }
                    }

                    if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if (this.cotaUnidade) {

                            if (this.formatSumMoney(this.unidadeSolicitante.cotaValor) <= this.cotaUnidade) {

                                this.limiteCota = true
                                this.cotaIdUnidadeSolicitante = cotaUnidade.id
                            }
                        }
                    } else {

                        if (this.cotaUnidade) {

                            if (this.unidadeSolicitante.cotaQuantidade <= this.cotaUnidade) {

                                this.limiteCota = true
                                this.cotaIdUnidadeSolicitante = cotaUnidade.id
                            }
                        }
                    }

                    if (this.cotaUnidade && this.limiteCota == true && this.addCota == false) {

                        this.getCotaAtribuida(this.cotaIdUnidadeSolicitante)
                    }
                })
        },
        getCotaAtribuida() {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            let verifyItem = this.data.model.cotasLaboratorio.map(item => item.cotaLaboratorio.filter(field =>

                field.cotaTipoId == this.cotalaboratorio.cotaTipoId
                && moment(

                    field.periodo.start.split("/").reverse().join("-")
                )
                .isBetween(
                    this.dataInicioUnidade,
                    this.dataFimUnidade,
                    null,
                    '[]'
                )
                && moment(
                    field.periodo.end.split("/").reverse().join("-")
                )
                .isBetween(
                    this.dataInicioUnidade,
                    this.dataFimUnidade,
                    null,
                    '[]'
                )
            )
            )

            Object.keys(verifyItem).forEach(a => {
                Object.keys(verifyItem[a]).forEach(b => {
                    Object.keys(verifyItem[a][b].exames).forEach(c => {

                        this.cotaAtribuida = verifyItem[a][b].exames[c].unidadeSolicitante.filter(field =>
                            field.unidadeSolicitanteId === this.unidadeSolicitante.unidadeSolicitanteId
                            && field.infraestruturaSolicitanteId === this.unidadeSolicitante.infraestruturaSolicitanteId
                        )
                        .reduce((sum, element) => {

                            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                                if (element.cota) {

                                    sum = sum + this.formatSumMoney(element.cota);
                                }
                            } else {

                                if (element.cota) {

                                    sum = Number(sum) + Number(element.cota);
                                }
                            }

                            return sum
                        },0)

                        if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                            this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                        } else {

                            this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
                        }
                    })
                })
            })

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                if (this.hasIndex) {

                    this.atribuiNovaCota = (this.cotasAtribuidas + this.formatSumMoney(this.unidadeSolicitante.cotaValor))
                        - this.formatSumMoney(this.cotaOld)

                } else {

                    this.atribuiNovaCota =  this.cotasAtribuidas + this.formatSumMoney(this.unidadeSolicitante.cotaValor)
                }

            } else {

                if (this.hasIndex) {

                    this.atribuiNovaCota =  (this.cotasAtribuidas + Number(this.unidadeSolicitante.cotaQuantidade))
                        - Number(this.cotaOld)

                } else {

                    this.atribuiNovaCota =  this.cotasAtribuidas +
                        Number(this.unidadeSolicitante.cotaQuantidade)
                }
            }

            if (this.cotaUnidade >= this.atribuiNovaCota) {

                this.addCota = true
            }
        },
        getCotaAtribuidaUnidadeSolicitante() {

            this.cotasAtribuidas = 0
            this.cotaAtribuida = 0

            this.cotaAtribuida = this.cotalaboratorio.unidadeSolicitante.filter(field =>
                field.unidadeSolicitanteId === this.unidadeSolicitante.unidadeSolicitanteId
                && field.infraestruturaSolicitanteId === this.unidadeSolicitante.infraestruturaSolicitanteId
            )
            .reduce((sum, element) => {

                if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                    if (element.cota) {

                        sum = sum + this.formatSumMoney(element.cota);
                    }

                } else {

                    if (element.cota) {

                        sum = Number(sum) + Number(element.cota);
                    }
                }

                return sum
            },0)

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
            } else {

                this.cotasAtribuidas = this.cotasAtribuidas + this.cotaAtribuida
            }

        },
        handleAlter(index, item) {

            this.resetForm()

            this.index = index

            this.unidadeSolicitante.id = item.id
            this.unidadeSolicitante.unidadeSolicitanteId = item.unidadeSolicitanteId
            this.unidadeSolicitante.infraestruturaSolicitanteId = item.infraestruturaSolicitanteId
            this.unidadeSolicitante.cotaQuantidade = item.cotaQuantidade
            this.unidadeSolicitante.cotaValor = item.cotaValor
            this.unidadeSolicitante.saldo = item.saldo
            this.unidadeSolicitante.transferencia = item.transferencia
            this.unidadeSolicitante.valorUtilizado = item.valorUtilizado
            this.unidadeSolicitante.quantidadeUtilizada = item.quantidadeUtilizada

            if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.cotaOld = item.cotaValor
            } else {

                this.cotaOld = item.cotaQuantidade
            }

            this.$refs.unidadeSolicitanteValor.$el.getElementsByTagName('input')[0].value = item.cotaValor;

            this.isReadOnly = true
            this.checkHandleAlter = true
        },
        hideAlter() {

            this.isReadOnly = false
            this.checkHandleAlter = false

            this.resetForm()
        },
        checkSum() {

            this.unidadeSolicitantesum = 0

            this.item.unidadeSolicitante.map(saldo => {

                if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(saldo.cota);
                } else {

                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(saldo.cota);
                }
            })
        },
        hasUnidadeParametrizada() {

            return this.data.model.cotasExamePeriodo.find((unidade, i) => i !== this.index
                && unidade.exameId == this.model.exameId && unidade.ano == this.model.ano)
        },
        handleDestroy(index, item) {

            const destroy = async () => {

                this.unidadeSolicitante.splice(index, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a cota para a
                <strong>${ item.unidadeSolicitante }</strong>?`,
                destroy)
        },
        resetForm() {

            this.unidadeSolicitante.id = null
            this.unidadeSolicitante.unidadeSolicitanteId = null
            this.unidadeSolicitante.infraestruturaSolicitanteId = null
            this.unidadeSolicitante.cotaValor= ''
            this.$refs.unidadeSolicitanteValor.$el.getElementsByTagName('input')[0].value = 0;
            this.unidadeSolicitante.cotaQuantidade= ''

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        getPrincipal(infraestruturaPrincipal) {

            this.unidadeSolicitante.infraestruturaSolicitanteId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        resetCotas() {
            this.cotaUnidade = null
            this.cotasAtribuidas = null
            this.cotaAtribuida = null
            this.limiteCota = false,
            this.cotaIdUnidadeSolicitante = null,
            this.addCota = false
        }
    },
    watch: {
        'item.unidadeSolicitante': function (unidadeSolicitante) {

            this.unidadeSolicitantesum = 0;

            unidadeSolicitante.map(saldo => {

                if (this.cotalaboratorio.cotaTipoId == this.enums.tipoCota.VALOR) {
                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + this.formatSumMoney(saldo.cota);
                } else {
                    this.unidadeSolicitantesum = this.unidadeSolicitantesum + Number(saldo.cota);
                }
            })
        },
    },
    mixins: [repository, object, data, formats],
    props: {
        data: { type: Object, required: true },
        item: { type: Object, required: true },
        indexExame: { type: [Number, String], required: true },
        indexItem: { type: Number, required: true },
        cotalaboratorio: { type: Object, required: true },
    },
}
</script>